import logo from './logo.svg';
import './App.css';
import { AllRoutes } from './Allroutes/AllRoutes';
import { Navbar } from './Components/Navbar';
import { useLocation } from 'react-router-dom';

function App() {
  const { pathname } = useLocation()

  return (
    <div className="App">
      {pathname === "/" ? <></> : <Navbar />}
      <AllRoutes />
    </div>
  );
}

export default App;
